/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterSubLimitSettingsQueryDto
 */
export interface FilterSubLimitSettingsQueryDto {
    /**
     * 
     * @type {string}
     * @memberof FilterSubLimitSettingsQueryDto
     */
    submissionId: string;
}

/**
 * Check if a given object implements the FilterSubLimitSettingsQueryDto interface.
 */
export function instanceOfFilterSubLimitSettingsQueryDto(value: object): value is FilterSubLimitSettingsQueryDto {
    if (!('submissionId' in value) || value['submissionId'] === undefined) return false;
    return true;
}

export function FilterSubLimitSettingsQueryDtoFromJSON(json: any): FilterSubLimitSettingsQueryDto {
    return FilterSubLimitSettingsQueryDtoFromJSONTyped(json, false);
}

export function FilterSubLimitSettingsQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterSubLimitSettingsQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'submissionId': json['submissionId'],
    };
}

export function FilterSubLimitSettingsQueryDtoToJSON(json: any): FilterSubLimitSettingsQueryDto {
    return FilterSubLimitSettingsQueryDtoToJSONTyped(json, false);
}

export function FilterSubLimitSettingsQueryDtoToJSONTyped(value?: FilterSubLimitSettingsQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submissionId': value['submissionId'],
    };
}

